import axios from "axios";

const organizations = {


    async bulk(params = {}){
        return (await axios.get('/api/organization', {params})).data;
    },

    async search(params = {}){
        return (await axios.get('/api/organization/search', {params})).data;
    }

}

export default organizations;
